import React from 'react';
import { Card } from '../ui/Card';
import { ProgressBar } from '../ui/ProgressBar';
import { executiveMetrics } from '../../data/reporting';
import { healthBar, pastDueHealth } from '../../utils/health';
export function PastDueBreakdown() {
  const m = executiveMetrics;
  const rows = [{
    label: 'Past Due Calls',
    value: m.pastDueCallPct
  }, {
    label: 'Past Due SMS',
    value: m.pastDueSmsPct
  }, {
    label: 'Past Due Emails',
    value: m.pastDueEmailPct
  }];
  return <Card className="px-6 py-5" data-id="element-348" data-mp="1bn662p4n2o89">
      <h2 className="text-sm font-semibold text-ink-900" data-id="element-349" data-mp="1bnxyjr2xw5ub">Past Due by Activity Type</h2>
      <p className="mt-0.5 text-xs text-ink-500" data-id="element-350" data-mp="1qkyl7g69xalx">
        Share of required activities not completed on time
      </p>
      <ul className="mt-5 space-y-4" data-id="element-351" data-mp="1lkargmqnufo0">
        {rows.map(row => <li key={row.label} data-id="element-352" data-mp="31zc406m66zv3">
            <div className="mb-1.5 flex items-center justify-between text-xs font-medium" data-id="element-353" data-mp="31y9d3youkxf6">
              <span className="text-ink-600" data-id="element-354" data-mp="2wzfz855nf4eh">{row.label}</span>
              <span className="tabular text-ink-900" data-id="element-355" data-mp="6xf9tiz38xkh">{row.value}%</span>
            </div>
            <ProgressBar value={row.value} max={20} label={row.label} barClassName={healthBar[pastDueHealth(row.value)]} data-id="element-356" data-mp="6zt0lfmqjnm8" />
          </li>)}
      </ul>
    </Card>;
}